// extracted by mini-css-extract-plugin
export var addToCartButton = "_r2-b";
export var arrowButtonContainer = "_r2-9";
export var arrowButtonIcon = "_r2-a";
export var carouselArrowButton = "_r2-6";
export var carouselElementContainer = "_r2-1";
export var galleryThumbnail = "_r2-d";
export var galleryThumbnailImage = "_r2-e";
export var left = "_r2-7";
export var productDisplayCarouselContainer = "_r2-0";
export var productTileContainer = "_r2-2";
export var productTileImage = "_r2-4";
export var productTileImageContainer = "_r2-3";
export var productTileTitle = "_r2-5";
export var right = "_r2-8";
export var sliderOverflow = "_r2-c";